// This file is referenced directly by gatsby during build so cannot contain named imports.
import {ObjectOfAny} from '@fo/shared-types';
import routes from './routes.json';

export const getRoutesData = (isTestEnv?: boolean): ObjectOfAny => {
  if (isTestEnv) {
    return {};
  }

  return routes;
};
